var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zen-objects-dropdown',{attrs:{"object-type":'Person',"value":_vm.internalValue,"placeholder":_vm.placeholder,"searchable":""},on:{"inputLegacy":_vm.onObjectChange}})}
var staticRenderFns = []

export { render, staticRenderFns }